import styled from 'styled-components';

import { styledTypography } from '@pkg/primitives';

import { tokens } from './tokens';

interface StyledNumberCounterProps {
    $monospace?: boolean;
    $compact?: boolean;
}

export const StyledNumberCounter = styled.div<StyledNumberCounterProps>`
    --yat_number-counter-width: ${({ $monospace }) => ($monospace ? '1ch' : 'auto')};

    --yat_number-counter-font-size: ${({ $compact }) =>
        $compact ? tokens.value.fontSize.compact : tokens.value.fontSize.default}px;
`;

export const Value = styled.p`
    ${styledTypography.tuskerBase};
    display: flex;
    font-size: var(--yat_number-counter-font-size);
    font-weight: 700;
    font-stretch: condensed;
    // Required to match the extended "descender" area
    // of Tusker when using only numbers.
    padding-top: 0.1em;
`;

export const Number = styled.span`
    // TODO: Our version of 'Tusker' does not appear
    // to support 'tabular-nums', so we have to
    // specify a 'width' of '1ch' for each character.
    display: block;
    flex: 0 0 auto;
    width: var(--yat_number-counter-width);
    text-align: center;
`;
